import axios from 'axios'

// Stale/legacy media domain baked into old DB rows (e.g. video_url, video_thumbnail).
// Rewrite it to the current backend so playback/downloads point at a reachable host.
const STALE_HOST_PATTERN = /^https?:\/\/[^/]*niyamasabha\.org/i

const rewriteStaleUrls = (value) => {
    if (typeof value === 'string') {
        return STALE_HOST_PATTERN.test(value)
            ? value.replace(STALE_HOST_PATTERN, process.env.REACT_APP_BASEURL)
            : value
    }
    if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) value[i] = rewriteStaleUrls(value[i])
        return value
    }
    if (value && typeof value === 'object') {
        for (const key of Object.keys(value)) value[key] = rewriteStaleUrls(value[key])
        return value
    }
    return value
}

/*exports a function commonAPI that takes in httpMethod,url,reqBody,reqHeader and returns a result
after making an api call using axios */
export const commonAPI = async (httpMethod,url,reqBody,reqHeader)=>{

    let reqConfig={
        method:httpMethod,
        url,
        data:reqBody,
        headers:reqHeader?reqHeader:{"Content-Type":"application/json"},

    }
    // response from API call using axios with reqConfig as argument is returned by the commonAPI function.
    return await axios(reqConfig).then(
        result=>{
            if (result?.data) rewriteStaleUrls(result.data)
            return result
        }
    ).catch(err=>{return err})
}
// ,'ngrok-skip-browser-warning': 69420
